"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const bind_1 = __importDefault(require("classnames/bind"));
const CommonPopup_scss_1 = __importDefault(require("@/components/popup/CommonPopup.scss"));
const CommonPopupFooter_1 = __importDefault(require("./CommonPopupFooter"));
const styles_1 = require("@mui/styles");
const cx = bind_1.default.bind(CommonPopup_scss_1.default);
const useStyles3 = (0, styles_1.makeStyles)(() => ({
    dialog: {
        marginTop: '-160px',
        borderRadius: '5px',
        borderWidth: '0px'
    }
}));
const CommonPopup = ({ title, iconType = 'error', content, toggleTopRightCancel, footerType = '3', leftBtnLabel, toggleLeftBtn, rightBtnDisabled = false, rightBtnLabel, toggleRightBtn }) => {
    const classes3 = useStyles3();
    const handleToggleTopRightCancel = () => {
        if (toggleTopRightCancel && typeof toggleTopRightCancel === 'function') {
            toggleTopRightCancel();
        }
    };
    const handleToggleLeftBtn = () => {
        if (toggleLeftBtn && typeof toggleLeftBtn === 'function') {
            toggleLeftBtn();
        }
    };
    const handleToggleRightBtn = () => {
        if (toggleRightBtn && typeof toggleRightBtn === 'function') {
            toggleRightBtn();
        }
    };
    return (react_1.default.createElement(material_1.Dialog, { open: true, classes: { paper: classes3.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: cx('common-popup-container') },
            react_1.default.createElement("div", { className: cx('common-popup-title-container') },
                react_1.default.createElement("div", { className: cx('common-popup-title') }, title),
                react_1.default.createElement("div", { className: cx('common-popup-close-icon'), onClick: handleToggleTopRightCancel })),
            react_1.default.createElement("div", { className: cx('common-popup-content-container') },
                iconType === 'success' ? react_1.default.createElement("div", { className: cx('common-popup-icon-success') }) : react_1.default.createElement("div", { className: cx('common-popup-icon') }),
                react_1.default.createElement("div", { className: cx('common-popup-content') }, content)),
            react_1.default.createElement(CommonPopupFooter_1.default, { footerType: footerType, leftLabel: leftBtnLabel, leftClickHandler: handleToggleLeftBtn, rightDisabled: rightBtnDisabled, rightLabel: rightBtnLabel, rightClickHandler: handleToggleRightBtn }))));
};
exports.default = CommonPopup;
